import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';

export const QUESTION_TYPES = {
  RATING: 'rating',
  MULTIPLE_CHOICE: 'multiple_choice',
  TEXT: 'text',
  BOOLEAN: 'boolean',
  MULTIPLE_SELECT: 'multiple_select',
  MULTIPLE_REVEAL: 'multiple_reveal',
  AUDIO: 'audio',
  TEXT_OR_AUDIO: 'text_or_audio',
  DESCRIPTION: 'description',
  DRAG_AND_DROP: 'drag_and_drop',
  HORIZONTAL_DRAG_DROP: 'horizontal_drag_drop',
  STYLED_BOOLEAN: 'styled_boolean',
  VIDEO_PLAYER: 'video_player',
  PDF: 'pdf',
} as const;

export type QuestionType = typeof QUESTION_TYPES[keyof typeof QUESTION_TYPES];

const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  [QUESTION_TYPES.RATING]: 'Rating Scale',
  [QUESTION_TYPES.MULTIPLE_CHOICE]: 'Multiple Choice',
  [QUESTION_TYPES.TEXT]: 'Text',
  [QUESTION_TYPES.BOOLEAN]: 'Yes/No',
  [QUESTION_TYPES.MULTIPLE_SELECT]: 'Multiple Select',
  [QUESTION_TYPES.MULTIPLE_REVEAL]: 'Multiple Reveal',
  [QUESTION_TYPES.AUDIO]: 'Audio Recording',
  [QUESTION_TYPES.TEXT_OR_AUDIO]: 'Text or Audio',
  [QUESTION_TYPES.DESCRIPTION]: 'Description',
  [QUESTION_TYPES.DRAG_AND_DROP]: 'Drag and Drop',
  [QUESTION_TYPES.HORIZONTAL_DRAG_DROP]: 'Horizontal Drag and Drop',
  [QUESTION_TYPES.STYLED_BOOLEAN]: 'Styled Boolean',
  [QUESTION_TYPES.VIDEO_PLAYER]: 'Video Player',
  [QUESTION_TYPES.PDF]: 'PDF Document',
};

interface QuestionTypeSelectProps {
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  disabled?: boolean;
}

export const QuestionTypeSelect: React.FC<QuestionTypeSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel>Question Type</InputLabel>
      <Select
        value={value}
        label="Question Type"
        onChange={onChange}
      >
        {Object.entries(QUESTION_TYPES).map(([key, value]) => (
          <MenuItem key={value} value={value}>
            {QUESTION_TYPE_LABELS[value as QuestionType]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
